import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  ProcessFlow,
  ProcessFlowCheckItem,
  ProcessFlowHistory,
  ProcessFlowStep,
  ProcessFlowStepItem,
  ProcessFlowStepItemNote,
} from './models/process-flow.model';
import { ProcessFlowService } from './service/process-flow.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
@Component({
  selector: 'app-process-flow',
  templateUrl: './process-flow.component.html',
  styleUrls: ['./process-flow.component.scss'],
})
export class ProcessFlowComponent implements OnInit {
  @ViewChild('timelineContainer') timelineContainer: ElementRef | undefined;
  user: any;
  processFlows: any;
  processFlow: ProcessFlow[] = [];
  loading: boolean = false;
  addNoteVisible: { [key: string]: boolean } = {};
  historyProcessFlow: {
    [key: string]: { process: ProcessFlowHistory[]; loading: boolean };
  } = {};
  historyProcessFlowStep: {
    [key: string]: { process: ProcessFlowHistory[]; loading: boolean };
  } = {};
  noteText: string = '';
  addNoteLoading: boolean = false;
  constructor(
    private processFlowService: ProcessFlowService,
    private authService: AuthService,
    public toastService: ToastService
  ) {
    this.user = this.authService.currentUserValue;
  }

  newItemDescription: string = '';

  ngOnInit(): void {
    this.loading = true;
    this.processFlowService.getProcessFlow().subscribe({
      next: (response: ProcessFlow[]) => {
        this.processFlow = response;
        this.processFlow.forEach((process: ProcessFlow) => {
          this.historyProcessFlow['process' + process.id] = {
            loading: false,
            process: [],
          };
        });
        this.loading = false;
      },
      error: () => {
        this.toastService.show('Erro ao carregar processos'),
          {
            classname: 'bg-warning text-center text-white',
            delay: 10000,
          };
        this.loading = false;
      },
    });
  }
  toggleItemCompletion(id: any) {}
  addItem() {}

  getStepById(processFlowIndex: number, stepDependencyId: number) {
    let indexStep = this.processFlow[processFlowIndex].steps.findIndex(
      (step: ProcessFlowStep) => {
        return step.id == stepDependencyId;
      }
    );
    if (indexStep > -1) {
      return this.processFlow[processFlowIndex].steps[indexStep];
    }
    return null;
  }

  checkDependency(processFlowIndex: number, step: ProcessFlowStep) {
    if (step.hasDependency) {
      let stepDependency = this.getStepById(
        processFlowIndex,
        step.dependencyStep ?? -1
      );
      if (stepDependency != null) {
        return !stepDependency.isDone;
      }
    }
    return false;
  }

  closeAddNote() {
    this.noteText = '';
    this.addNoteVisible = {};
  }
  openAddNote(item: string) {
    this.noteText = '';
    this.addNoteVisible = {};
    this.addNoteVisible[item] = true;
  }
  showSideBarAddNote(item: string) {
    if (Object.keys(this.addNoteVisible).includes(item)) {
      return this.addNoteVisible[item];
    }
    return false;
  }

  updateStepIsDone(processFlowCheckItem:ProcessFlowCheckItem) {
    this.processFlowService
      .updateStepIsDone(processFlowCheckItem)
      .subscribe({
        complete: () => {
          this.toastService.show('Passo completado com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
        },
        error: () => {
          this.toastService.show('Erro ao completar o passo.'),
            {
              classname: 'bg-warning text-center text-white',
              delay: 10000,
            };
        },
      });
  }

  updateCheckItem(
    step: ProcessFlowStep,
    item: ProcessFlowStepItem,
    event: any
  ) {
    let stepIsDoneBefore =
      step.items.findIndex((itemAux: ProcessFlowStepItem) => {
        return !itemAux.isDone;
      }) == -1;
    item.isDone = event.currentTarget.checked;
    let stepIsDoneAfter =
      step.items.findIndex((itemAux: ProcessFlowStepItem) => {
        return !itemAux.isDone;
      }) == -1;

    let processFlowCheckItem: ProcessFlowCheckItem = {
      processFlowId: step.processFlowId,
      processFlowStepId: step.id,
      processFlowStepItemId: item.id,
      value: item.isDone ? 1 : 0,
      userId: this.user.userId,
    };

    this.processFlowService.updateCheckItem(processFlowCheckItem).subscribe({
      complete: () => {
        this.toastService.show('Item checkado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        if (stepIsDoneAfter && !stepIsDoneBefore) {
          step.isDone = true;
          processFlowCheckItem.value = 1;
          this.updateStepIsDone(processFlowCheckItem);
        } else if (stepIsDoneBefore && !stepIsDoneAfter) {
          step.isDone = false;
          processFlowCheckItem.value = 0;
          this.updateStepIsDone(processFlowCheckItem);
        }
      },
      error: () => {
        this.toastService.show('Erro ao checkar item'),
          {
            classname: 'bg-warning text-center text-white',
            delay: 10000,
          };
      },
    });
  }
  saveNote(
    processFlowIndex: number,
    processFlowStepIndex: number,
    processFlowStepItemIndex: number,
    item: ProcessFlowStepItem
  ) {
    this.addNoteLoading = true;
    let processFlowStepItemNote: ProcessFlowStepItemNote = {
      note: this.noteText,
      process_FlowStepId: item.process_FlowStepId,
      processFlowStepItemId: item.id,
      userIdCreated: this.user.userId,
      isActive: true,
      date: new Date(),
    };
    this.processFlowService
      .addProcessFlowStepItemNote(processFlowStepItemNote)
      .subscribe({
        complete: () => {
          this.processFlow[processFlowIndex].steps[processFlowStepIndex].items[
            processFlowStepItemIndex
          ].notes?.push(processFlowStepItemNote);
          this.toastService.show('Nota adicionada com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.addNoteLoading = false;
          this.closeAddNote();
        },
        error: () => {
          this.toastService.show('Erro ao adicionar nota'),
            {
              classname: 'bg-warning text-center text-white',
              delay: 10000,
            };
          this.addNoteLoading = false;
        },
      });
  }

  getHistoryProcessFlow(processId: number) {
    this.historyProcessFlow['process' + processId].process = [];
    this.historyProcessFlow['process' + processId].loading = true;

    this.processFlowService.getHistoryProcessFlow(processId).subscribe({
      next: (response: ProcessFlowHistory[]) => {
        this.historyProcessFlow['process' + processId].process = response;
        this.historyProcessFlow['process' + processId].loading = false;
      },
      error: (error: any) => {
        this.historyProcessFlow['process' + processId].loading = false;
      },
    });
  }
  canUpdate() {
    let element: HTMLElement | null = document.getElementById(
      'tools_process_flow_update'
    );
    if (element != undefined && element != null) {
      return true;
    }
    return false;
  }
  // ngAfterViewInit() {
  //   this.drawConnectors();
  // }

  // drawConnectors() {
  //   const container = this.timelineContainer!.nativeElement;
  //   const svg: SVGElement = container.querySelector('svg');

  //   // Obter os elementos dos passos
  //   const items = Array.from(container.querySelectorAll('.timeline-item'));

  //   items.forEach((item: any, index: any) => {
  //     const step = this.processFlow.steps![index];

  //     if (step.nextStepId) {
  //       const nextStep = container.querySelector(`#step-${step.nextStepId}`);
  //       if (nextStep) {
  //         this.drawLine(item, nextStep, svg);
  //       }
  //     }

  //     if (step.nextStepIfNot) {
  //       const nextStepIfNot = container.querySelector(
  //         `#step-${step.nextStepIfNot}`
  //       );
  //       if (nextStepIfNot) {
  //         this.drawLine(item, nextStepIfNot, svg);
  //       }
  //     }
  //   });
  // }

  // drawLine(from: HTMLElement, to: HTMLElement, svg: SVGElement) {
  //   const fromRect = from.getBoundingClientRect();
  //   const toRect = to.getBoundingClientRect();
  //   const containerRect =
  //     this.timelineContainer!.nativeElement.getBoundingClientRect();

  //   const x1 = fromRect.right - containerRect.left;
  //   const y1 = fromRect.top - containerRect.top + fromRect.height / 2;
  //   const x2 = toRect.left - containerRect.left;
  //   const y2 = toRect.top - containerRect.top + toRect.height / 2;

  //   const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  //   line.setAttribute('x1', x1.toString());
  //   line.setAttribute('y1', y1.toString());
  //   line.setAttribute('x2', x2.toString());
  //   line.setAttribute('y2', y2.toString());
  //   line.setAttribute('class', 'timeline-connector');

  //   svg.appendChild(line);
  // }
}
